import countries from "../data/countries.json";

export const COUNTRIES_QUERY_KEY = ["countries"];

// The country list used to come from the restcountries.com REST API, which now
// requires an API access token and enforces rate limits (BEP-1891). The list is
// effectively static, so we bundle it (fields: name, cca2, translations) and
// serve it locally instead of making network calls. Mirrors beppo-app's fix.
export const useCountries = () => {
  return {
    data: countries,
    isLoading: false,
    isError: false,
    error: null,
  };
};
